interface SvgInterface {
    className?: string;
    style?: any;
}
export function DotsIcon({className = '', style = {}}: SvgInterface) {
    return <svg className={`bi bi-three-dots-vertical ${className}`} style={{...style}} fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/></svg>;
}